import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { IoAlertCircleOutline } from 'react-icons/io5';
import Modall from '../../Modall';
import { urlToFile } from '../../../util/files';
const GET_URL = 'admin/qualification/instructor'

// שדות החתימה מקבלים תמונות מסוג JPG / JPEG / PNG בלבד
const ALLOWED_SIGNATURE_MIME_TYPES = ['image/jpeg', 'image/png'];
const ALLOWED_SIGNATURE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
const SIGNATURE_ACCEPT = '.jpg,.jpeg,.png,image/jpeg,image/png';
const SIGNATURE_FORMATS_HINT = 'JPG, JPEG או PNG';

// נוסח הודעות השגיאה בדף: אומרות למשתמש מה לעשות, לא רק מה חסר
const ERROR_MESSAGES = {
    training_manager: 'יש להזין את שם מנהל ההדרכה',
    training_imgSignature: 'יש להעלות את חתימת מנהל ההדרכה',
    unsupportedSignatureFile: `הקובץ שנבחר אינו נתמך ולא נקלט. ניתן להעלות תמונה בלבד בפורמט ${SIGNATURE_FORMATS_HINT}`,
};

// בודק שהקובץ הוא תמונה נתמכת - גם לפי סוג ה-MIME וגם לפי סיומת הקובץ
const isAllowedSignatureImage = (file) => {
    if (!file) return false;
    const extension = file.name?.split('.').pop()?.toLowerCase();
    return ALLOWED_SIGNATURE_MIME_TYPES.includes(file.type)
        && ALLOWED_SIGNATURE_EXTENSIONS.includes(extension);
};

// הודעת שגיאה מתחת לשדה: ברוחב השדה ומיושרת אליו, עם אייקון, בכיוון ימין-לשמאל
const FieldError = ({ message }) => {
    if (!message) return null;
    return (
        <div className='w-full flex justify-end'>
            <p dir='rtl' role='alert' className='w-1/2 mt-1 flex items-center gap-1 text-right text-xs text-red-600'>
                <IoAlertCircleOutline className='shrink-0 text-base' />
                <span>{message}</span>
            </p>
            <span className='w-[30%]' />
        </div>
    );
};


const ModalNewGuides = ({ showModal, children, handleColse, getDepartment, row = "" }) => {
    // const [previewUrl, setPreviewUrl] = useState('');
    const [formData, setFormData] = useState(
        // row ?
        //     {
        //         frame_manager: row?.frame_manager,
        //         training_manager: row?.training_manager,
        //         training_imgSignature: null,
        //         frame_imgSignature: null,
        //         training_imgSignature_url: row?.training_imgSignature ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.training_imgSignature}` : "",
        //         frame_imgSignature_url: row?.frame_imgSignature ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.frame_imgSignature}` : "",
        //     } :
        {
            frame_manager: "",
            training_manager: '',
            frame_imgSignature: null,
            frame_imgSignature_url: "",
            training_imgSignature: null,
            training_imgSignature_url: "",
        });
    const [file, setFile] = useState(null)
    const [errors, setErrors] = useState({});

    // מסיר את השגיאה של שדה מסוים, למשל אחרי שהמשתמש תיקן אותו
    const clearFieldError = (name) => {
        setErrors((prev) => {
            if (!prev[name]) return prev;
            const newErrors = { ...prev };
            delete newErrors[name];
            return newErrors;
        });
    };

    const handleChange = (e) => {
        console.log(e.target)
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        clearFieldError(name);
    };


    useEffect(() => { console.log(formData) }, [formData])
    const validate = (id) => {
        const newErrors = {};
        // if (!formData.frame_manager) newErrors.frame_manager = 'שדה חובה';
        if (!formData.training_manager &&!id) newErrors.training_manager = ERROR_MESSAGES.training_manager;
        // if (!formData.frame_imgSignature) newErrors.frame_imgSignature = 'שדה חובה';
        if (!formData.training_imgSignature &&!id) newErrors.training_imgSignature = ERROR_MESSAGES.training_imgSignature;


        return newErrors;
    };

    const handleSubmit = () => {
        // e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            // Submit the form data
            // console.log(formData)
            addNewGuides()
        }
    };




    const handleFileChange = (event) => {
        const input = event.target;
        const { name } = input;
        const file = input.files[0];

        // המשתמש ביטל את חלון בחירת הקובץ
        if (!file) return;

        // קובץ שאינו תמונה מסוג JPG / JPEG / PNG (למשל PDF) - דוחים אותו:
        // מאפסים את שדה הבחירה ומציגים שגיאה. הקובץ והתצוגה המקדימה הקודמים נשארים ללא שינוי.
        if (!isAllowedSignatureImage(file)) {
            input.value = '';
            setErrors((prev) => ({ ...prev, [name]: ERROR_MESSAGES.unsupportedSignatureFile }));
            return;
        }

        // עדכון השדה המתאים בהתאם לשם
        setFormData((prev) => ({
            ...prev,
            [name]: file
        }));

        const reader = new FileReader();
        reader.onload = (e) => {
            setFormData((prev) => ({
                ...prev,
                [`${name}_url`]: e.target.result
            }));
        };
        reader.readAsDataURL(file);

        // בחירה תקינה מנקה שגיאה קודמת של השדה (שדה חובה / סוג קובץ לא נתמך)
        clearFieldError(name);
    };

    useEffect(() => {
        const fetchFile = async () => {
            if (row) {
                let file1 = null
                let file2 = null
                if (row?.training_imgSignature)
                    file1 = await urlToFile(`https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.training_imgSignature}`, row?.training_imgSignature.split('/').pop())
                if (row?.frame_imgSignature)
                    file2 = await urlToFile(`https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.frame_imgSignature}`, row?.frame_imgSignature.split('/').pop())
                setFormData((prev) => ({
                    ...prev,
                    training_imgSignature: file1,
                    frame_imgSignature: file2,

                }
                ))
            }

        };

        fetchFile();
    }, [])






    const handleEditClass = async (id) => {
        const validationErrors = validate(id);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            let formData1 = new FormData();
            formData1.append('instructorDetails', JSON.stringify({
                "frame_manager": formData.frame_manager,
                "training_manager": formData.training_manager,
            }));
            console.log(formData1)
            formData1.append('training_img_Signature ', formData.training_imgSignature);
            formData1.append('frame_img_Signature', formData.frame_imgSignature);
            const response = await axios.put(`${GET_URL}/${id}`, formData1
                ,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
            if (response.status == 200) {
                getDepartment()
                handleColse()
                console.log("Edit")
            }
        }
    }
    // const urlToFile = async (imageUrl, fileName) => {
    //     const response = await axios.get(imageUrl, { responseType: 'blob' })
    //     const blob = await response.blob();
    //     return new File([blob], fileName,  { type: "image/jpeg" });
    // };

    const addNewGuides = async () => {

        let formData1 = new FormData();
        formData1.append('instructorDetails', JSON.stringify({
            "frame_manager": formData.frame_manager,
            "training_manager": formData.training_manager,
        }));
        console.log(formData1)
        formData1.append('training_img_Signature ', formData.training_imgSignature);
        formData1.append('frame_img_Signature', formData.frame_imgSignature);

        const response = await axios.post(GET_URL, formData1

            ,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            })



        // const response = await axios.post(GET_URL,{
        //     [{'instructorDetails':{ 
        //     "name": formData.fullname,
        //     "identity": formData.identity,
        //     "phone": formData.phone}},
        //     "img_Signature": file]
        // }     
        // , {
        //     headers: { 'Content-Type': 'multipart/form-data' }
        // })
        console.log(response)
        if (response?.status == 200) {
            // setnamecalss("")
            getDepartment()
            handleColse()
        }
        else {
            console.log("error add class")
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            if (row) {
                try {


                    let file1 = null;
                    let file2 = null;

                    if (row?.training_imgSignature)
                        file1 = await urlToFile(
                            `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.training_imgSignature}`,
                            // response?.data?.imgFacePicture
                            row?.training_imgSignature?.split('/').pop()
                        );

                    if (row?.frame_imgSignature)
                        file2 = await urlToFile(
                            `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.frame_imgSignature}`,
                            row?.frame_imgSignature?.split('/').pop()
                        );

                    setFormData({
                        frame_manager: row?.frame_manager,
                        training_manager: row?.training_manager,
                        training_imgSignature: file1 || null,
                        frame_imgSignature: file2 || null,
                        training_imgSignature_url: row?.training_imgSignature ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.training_imgSignature}` : "",
                        frame_imgSignature_url: row?.frame_imgSignature ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${row?.frame_imgSignature}` : "",

                    });


                }
                 catch (err) {
                console.error("שגיאה בקבלת הנתונים:", err);
            }
        }
    };

    fetchData();
}, []);




return (
    <Modall showModal={showModal}>
        <div className=' w-full divide-y-2  divide-slate-500'>
            <div className='w-full bg-[#0d406b] flex justify-end'>
                <button className='p-1 px-2 m-3 border bg-slate-500 hover:bg-slate-200' onClick={() => {
                    handleColse()
                }} >x</button>
            </div>


            <form className='w-full p-5 flex flex-col  text-center text-sm'>
                <div className='w-full pt-2 flex justify-end'>

                    <input
                        className={`w-1/2 border text-right ${errors.frame_manager ? 'border-red-500' : ''}`}
                        type="text"
                        id="frame_manager"
                        name="frame_manager"
                        value={formData.frame_manager}
                        onChange={handleChange}
                    />
                    {/* <label htmlFor="frame_manager " className='w-[30%]'><p className='ml-2'><span className='text-red-600'>*</span>מנהל מסגרת</p></label> */}
                    <label htmlFor="frame_manager " className='w-[30%]'><p className='ml-2'>מנהל מסגרת</p></label>

                </div>
                <FieldError message={errors.frame_manager} />

                <div className='w-full pt-2 flex justify-end'>

                    <input
                        className={`border w-1/2 text-right ${errors.training_manager ? 'border-red-500' : ''}`}
                        type="text"
                        id="training_manager"
                        name="training_manager"
                        value={formData.training_manager}
                        onChange={handleChange}
                    />
                    <label htmlFor="training_manager" className='w-[30%]'><p className='ml-2'><span className='text-red-600'>*</span>מנהל הדרכה</p></label>

                </div>
                <FieldError message={errors.training_manager} />


                <div className="w-full pt-2 flex justify-end">

                    <input
                        className={`border w-1/2 h-fit ${errors.frame_imgSignature ? 'border-red-500' : ''}`}
                        type="file"
                        accept={SIGNATURE_ACCEPT}
                        id="frame_imgSignature"
                        name="frame_imgSignature"
                        // value={formData.urlimage}
                        onChange={handleFileChange}
                    />
                    <label htmlFor="frame_imgSignature" className='w-[30%]'><p className='ml-2'>חתימה של מנהל המסגרת (העלאת הקובץ)<span className='block text-xs text-slate-600'>תמונה בלבד: {SIGNATURE_FORMATS_HINT}</span></p></label>

                </div>



                {/* <div className="w-full pt-2 flex justify-end">

                        <input
                            className='border w-1/2 text-right bg-slate-300'
                            type="text"
                            id="urlimage"
                            name="urlimage"
                            value={formData.urlimage}
                        // disabled
                        />
                        <label htmlFor="urlimage" className='w-[30%]'><p className='ml-2'><span className='text-red-600'>*</span>חתימה (הקישור)</p></label>

                    </div> */}
                {/* {errors.urlimage && <span className="error">{errors.urlimage}</span>} */}
                <FieldError message={errors.frame_imgSignature} />
                {<img className='w-[160px] h-[160px]  object-cover m-4 mb-0 flex self-end' src={formData?.frame_imgSignature_url || "https://ismb.tech-bar.co.il/resources/images/imagelists/default-image.png"} />}


                <div className="w-full pt-2 flex justify-end">

                    <input
                        className={`border w-1/2 h-fit ${errors.training_imgSignature ? 'border-red-500' : ''}`}
                        type="file"
                        accept={SIGNATURE_ACCEPT}
                        id="training_imgSignature"
                        name="training_imgSignature"
                        // value={formData.urlimage}
                        onChange={handleFileChange}
                    />
                    <label htmlFor="training_imgSignature" className='w-[30%] '><p className='ml-2'><span className='text-red-600'>*</span>חתימה של מנהל ההדרכה (העלאת הקובץ)<span className='block text-xs text-slate-600'>תמונה בלבד: {SIGNATURE_FORMATS_HINT}</span></p></label>

                </div>



                {/* <div className="w-full pt-2 flex justify-end">

                        <input
                            className='border w-1/2 text-right bg-slate-300'
                            type="text"
                            id="urlimage"
                            name="urlimage"
                            value={formData.urlimage}
                        // disabled
                        />
                        <label htmlFor="urlimage" className='w-[30%]'><p className='ml-2'><span className='text-red-600'>*</span>חתימה (הקישור)</p></label>

                    </div> */}
                {/* {errors.urlimage && <span className="error">{errors.urlimage}</span>} */}
                <FieldError message={errors.training_imgSignature} />
                {<img className='w-40 h-40 object-cover m-4 mb-0 flex self-end' src={formData?.training_imgSignature_url || "https://ismb.tech-bar.co.il/resources/images/imagelists/default-image.png"} />}




            </form>
            <div className='w-full p-2   flex justify-end'>
                <button className='border bg-green-500 hover:bg-green-300 p-1 px-3' onClick={() => {

                    row ? handleEditClass(row.id) : handleSubmit()

                    // handleSubmit()


                }}>שמור</button>
                <button className='border bg-slate-700 hover:bg-slate-500 p-1 px-3' onClick={() => {
                    // reset()
                    // setShowModal(false)
                    handleColse()
                }}>בטל</button>
            </div>
        </div>

    </Modall>
)

}

export default ModalNewGuides